export default __webpack_public_path__ + "static/media/refer.ffd499ac.png";